(ns pfo.dashboard.core
  (:require [pfo.util :as util]
            [pfo.dashboard.component :as component]))

(defn dashboard [{:keys [query-params]}]
  (util/set-page #'component/dashboard {:focus-dropbox-sign-pending (= (:dss query-params) "1")}))
